<template>
  <div class="NavSecond">
    <router-link v-if="!item.hidden" :to="item.url" tag="div" class="item" :class="$route.path.indexOf(item.name) != -1?'active':''" :key="item.url" v-for="(item,index) in secondArr">
      <img :src="$route.path.indexOf(item.name) == -1?item.icon:item.icon_current" alt="">
      <span>{{item.title}}</span>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: "NavSecond",
    data() {
      return {
        secondArr: []
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        if(val =='zh'){
          this.$store.getters.menu.forEach((val) => {
            if (this.$route.path.indexOf(val.name) != -1) {
              this.secondArr = val.child
            }
          })
        }else{
          this.$store.getters.menuEn.forEach((val) => {
            if (this.$route.path.indexOf(val.name) != -1) {
              this.secondArr = val.child
            }
          })
        }
      }
    },
    created() {
      if(this.$store.getters.lang =='zh'){
        this.$store.getters.menu.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.secondArr = val.child
          }
        })
      }else{
        this.$store.getters.menuEn.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.secondArr = val.child
          }
        })
      }
    },
  }
</script>

<style scoped lang="less">
  .NavSecond {
    display: flex;
    justify-content: center;
    height: 82px;
    width: 100%;
    background: #f0f2f6;

    .item {
      height: 100%;
      display: flex;
      font-family: Source Han Sans CN;
      font-size: 24px;
      color: #555;
      padding: 0 50px;
      align-items: center;
      cursor: pointer;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 1px;
        height: 26px;
        background: #989898;
        opacity: 0.5;
      }

      img {
        margin-right: 10px;
      }
    }

    .item:first-child::after {
      display: none;
    }

    .item.active {
      color: #FFFFFF;
      background: #DA1E2D;

    }
  }
</style>



// WEBPACK FOOTER //
// src/common/NavSecond.vue